<template>
  <div
    class="content has-text-left"
    :class="{ 'direction-rtl': Language == 'fa' || Language == 'ar' }"
  >
    <div
      class="modal large"
      :class="{ 'is-active': modal.subIBClients.active }"
    >
      <div class="modal-background"></div>
      <div class="modal-card">
        <section class="modal-card-body">
          <div class="columns">
            <div class="column">
              <sub-ib-clients :IBID="modal.subIBClients.subIBID"></sub-ib-clients>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot right">
          <button
            class="button"
            @click="modal.subIBClients.active = false"
          >{{ $t('cancel').tUpper() }}</button>
        </footer>
      </div>
    </div>

    <table
      id="ib-subibs"
      class="table"
    >
      <thead>
        <tr>
          <th>{{ $t('status').tUpper() }}</th>
          <th>
            {{ $t('date_joined').tUpper() }}
            <div class="arrow">
              <div class="line line-1"></div>
              <div class="line line-2"></div>
            </div>
          </th>
          <th>
            {{ $t('full_name').tUpper() }}
            <div class="arrow">
              <div class="line line-1"></div>
              <div class="line line-2"></div>
            </div>
          </th>
          <th>
            {{ $t('total_commission_generated').tUpper() }}
            <div class="arrow">
              <div class="line line-1"></div>
              <div class="line line-2"></div>
            </div>
          </th>
          <th>{{ $t('total_deposits').tUpper() }}</th>
          <th>{{ $t('total_withdrawals').tUpper() }}</th>
          <th></th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="subIB in IBSubIBs"
          :key="`sub-ib-${subIB.sub_ib_id}`"
        >
          <td>{{ $statusFormat(subIB.status) }}</td>
          <td>{{ $formatDate(subIB.date_joined) }}</td>
          <td>{{ subIB.full_name }}</td>
          <td>
            <span v-if="subIB.total_parent_commission_generated">
              {{ $formatMoney(subIB.total_parent_commission_generated, currencies['USD'].symbol) }}
            </span>
          </td>
          <td>
            <span
              v-for="(value, currency) in subIB.total_deposits"
              :key="`total-${currency}-deposits`"
            >
              {{ $formatMoney(value, currencies[currency].symbol) }}
            </span>
          </td>
          <td>
            <span
              v-for="(value, currency) in subIB.total_withdrawals"
              :key="`total-${currency}-withdrawals`"
            >
              {{ $formatMoney(value, currencies[currency].symbol) }}
            </span>
          </td>
          <td>
            <a
              class="button is-primary is-outlined"
              @click="openSubIBDetailsModal(subIB.sub_ib_id)"
            >
              <span>{{$t('clients').tUpper()}}</span>
            </a>
          </td>
        </tr>
      </tbody>
    </table>

    <pagination
      for="ib-client"
      :records="pagination.total"
      :per-page="pagination.maxItemsPerPage"
      :chunk="4"
      :count-text="pagination.total + ' ' + $t('records')"
    ></pagination>
  </div>
</template>

<script>
import { Pagination, PaginationEvent } from 'vue-pagination-2-bulma'
import { mapActions, mapGetters } from 'vuex'
import { service } from '../../app'
import config from '../../config'
import SubIbClients from './Clients.vue'

export default {
  components: {
    Pagination,
    SubIbClients,
  },
  data() {
    return {
      IBSubIBs: [],
      currencies: config.currencies,
      pagination: {
        page: 0,
        total: 0,
        maxItemsPerPage: 10,
      },

      modal: {
        subIBClients: {
          active: false,
          subIBID: null,
        },
      },
    }
  },
  computed: {
    ...mapGetters({
      User: 'user/all',
      Requests: 'requests/all',
      Language: 'language/code',
    }),
  },
  mounted() {
    // clients pagination
    PaginationEvent.$on('vue-pagination::ib-client', page => {
      this.pagination.page = page
      this.getIBSubIBs(page)
    })

    this.getIBSubIBs(1)
  },
  methods: {
    openSubIBDetailsModal(subIBID) {
      // Load sub IB clients like Clients.vue.
      this.modal.subIBClients.subIBID = subIBID
      this.modal.subIBClients.active = true
    },
    getIBSubIBs(page) {
      if (!page) {
        if (this.pagination.page) {
          page = this.pagination.page
        } else {
          page = 1
        }
      }

      this['logoLoader/set'](true)
      service
        .post('/ib/sub-ibs', {
          userID: this.User.info.ID,
          page: page,
        })
        .then(response => {
          if (typeof response.data.IBSubIBs !== 'undefined') {
            this.IBSubIBs = response.data.IBSubIBs
            this.pagination.total = response.data.CountIBSubIBs
          }
          this['logoLoader/set'](false)
        })
        .catch(() => {
          this['logoLoader/set'](false)
        })
    },
    ...mapActions(['logoLoader/set', 'user/setIB']),
  },
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// SubIBs.vue?b1bcbdfa